import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const details: Record<TComponentValue<'QmulusLicenseViolationReason'>, string> = {
  NO_LICENSE_KEY: 'Um Qmulus weiterhin nutzen zu können, muss ein valider Lizenzschlüssel hinterlegt werden.',
  ASSET_LIMIT_VIOLATED: 'Es sind zu viele Assets konfiguriert',
  EXPIRED: 'Der Lizenzschlüssel ist mehr als {expiryGracePeriodDays} Tag(e) abgelaufen.',
  EXPIRED_GRACE_PERIOD: 'Der Lizenzschlüssel ist abgelaufen und muss schnellst möglich aktualisiert werden, bevor der Zugang zu Qmulus gesperrt wird.',
  INVALID: 'Der eingegebene Lizenzschlüssel ist ungültig.',
  USER_LIMIT_VIOLATED: 'Es sind zu viele Benutzer registriert.',
  OTHER: 'Unbekannter Fehler beim verifizieren der Lizenz.',
};

export default {
  enterLicense: 'Lizenzschlüssel eingeben',
  contactSales: 'Um einen aktualisierten Lizenschlüssel zu erhalten, setzen Sie sich mit ihrem Qmulus Ansprechpartner in verbindung.',
  ignore: 'Ignorieren',
  expiresSoon: {
    summary: 'Der Lizenzschlüssel läuft bald ab',
    details: 'Der Lizenzschlüssel läuft am {date} ab.',
  },
  details,
};
